import axios from "@/plugins/axios";

let url = "/api/v1/portfolios/spaces";

export default {
    getSpaces(data){
        return axios.get(url, data).then(result => result.data);
    }
}
